import type { CartExperimentState } from '@/types/cart-experiment';

/** 购物车页不展示预览；其他 PC 页面复用同一真实分桶，第 3/4 组使用新版侧栏。 */
export function getCartSidebarPresentation(
  pathname: string,
  isMobile: boolean,
  experiment: CartExperimentState,
): 'legacy' | 'v1' {
  return !isMobile &&
    pathname !== '/cart' &&
    experiment.status === 'resolved' &&
    (experiment.value === 3 || experiment.value === 4)
    ? 'v1'
    : 'legacy';
}
